<div>
  <app-display-icon
    [icon]="params.additionalData.icon"
    [colour]="params.additionalData.colour"
    [tooltip]="params.additionalData.tooltip ?? (params.additionalData.showMinutes ? params.value + ' minutes' : params.value)">
  </app-display-icon>
</div>